import { api } from './baseApi';
var buildQuery = function (p) {
    var params = new URLSearchParams();
    Object.entries(p).forEach(function (_a) {
        var k = _a[0], v = _a[1];
        if (v !== undefined && v !== null && String(v) !== '')
            params.append(k, String(v));
    });
    return params.toString();
};
export var analyticsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getScreenAnalyticsSummary: builder.query({
                query: function (p) {
                    return ({
                        url: "/analytics/screens/summary?".concat(buildQuery(p)),
                        method: 'GET',
                    });
                },
                providesTags: ['ScreenAnalytics'],
            }),
            getScreenAnalyticsFlows: builder.query({
                query: function (p) {
                    return ({
                        url: "/analytics/screens/flows?".concat(buildQuery(p)),
                        method: 'GET',
                    });
                },
                providesTags: ['ScreenAnalytics'],
            }),
            getSessionAnalyticsSummary: builder.query({
                query: function (p) {
                    return ({
                        url: "/analytics/sessions/summary?".concat(buildQuery(p)),
                        method: 'GET',
                    });
                },
                providesTags: ['ScreenAnalytics'],
            }),
        });
    },
    overrideExisting: false,
});
export var useGetScreenAnalyticsSummaryQuery = analyticsApi.useGetScreenAnalyticsSummaryQuery, useGetScreenAnalyticsFlowsQuery = analyticsApi.useGetScreenAnalyticsFlowsQuery, useGetSessionAnalyticsSummaryQuery = analyticsApi.useGetSessionAnalyticsSummaryQuery;
